
import {
	AssignmentFilterType,
} from '.';
import {
	Status,
	Assignment,
} from '../../models/assignment.model';

export const STATUS_TODO = [
	Status.Planned,
	Status.ReadyForPickup,
];

export const STATUS_DONE = [
	Status.Delivered,
	Status.Completed,
	Status.Received,
	Status.Unloaded,
	Status.Loaded,
];

const isTodo = (data: Assignment) => countAllTodo([data]) > 0;
const isDone = (data: Assignment) => countAllDone([data]) > 0;
const countAllTodo = (datas: Assignment[]) => STATUS_TODO.reduce((sum: number, status: Status) => sum + countAllByStatus(datas, status), 0);
const countAllDone = (datas: Assignment[]) => STATUS_DONE.reduce((sum: number, status: Status) => sum + countAllByStatus(datas, status), 0);
const countAllByStatus = (datas: Assignment[], status: Status) =>
	datas.reduce((count: number, assignment: Assignment) => (assignment.status === Status[status] ? count + 1 : count), 0);

const countAllTodoOnFilter = (assignments: Assignment[], filter: AssignmentFilterType) =>
	assignments.reduce((sum, data) => (isTodo(data) && (
		filter === AssignmentFilterType.ALL || AssignmentFilterType[filter] === data?.direction) ? sum + 1 : sum) ,0);

const countAllDoneOnFilter = (assignments: Assignment[], filter: AssignmentFilterType) =>
	assignments.reduce((sum, data) => (isDone(data) && (
		filter === AssignmentFilterType.ALL || AssignmentFilterType[filter] === data?.direction) ? sum + 1 : sum) ,0);


export {
	isTodo,
	isDone,
	countAllTodo,
	countAllDone,
	countAllByStatus,
	countAllTodoOnFilter,
	countAllDoneOnFilter,
}